import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import ClickableTypePicker from './ClickableTypePicker';
import ClickablePresetEditor from './ClickablePresetEditor';

/**
 * ClickableSection (presentational)
 * - Render UI untuk memilih clickable_type dan preview shape
 * - State & dispatch tetap ditangani oleh parent (QuestionsForm.jsx)
 */
export default function ClickableSection(props) {
  const {
    clickableType,
    options,
    onChangeClickableType,
    isDisabled,
    isPresetDisabled,
    variant,
    preset,
    onChangePreset,
  } = props;

  return (
    <FormGroup className="mb-3">
      <Label style={{ fontWeight: 'bold' }}>{'Tipe Clickable'}:</Label>

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <div style={{ flex: 1 }}>
          {/* Admin bisa pilih tipe clickable via click (lebih cepat dari dropdown) */}
          <ClickableTypePicker
            value={clickableType}
            options={options}
            onChange={onChangeClickableType}
            isDisabled={isDisabled}
          />

          {/* Saat tipe sudah dipilih, admin bisa set nilainya langsung via klik Konva */}
          {clickableType && (
            <div style={{ marginTop: 12 }}>
              <ClickablePresetEditor
                variant={variant}
                preset={preset}
                // NOTE: Saat update, tipe biasanya di-lock, tapi nilai masih boleh diubah.
                isDisabled={Boolean(isPresetDisabled)}
                onChangePreset={onChangePreset}
                height={320}
              />
            </div>
          )}
        </div>

        {/* Preview hanya tampil jika clickableType sudah dipilih */}
        {/* {clickableType && (
          <div>
            <ModalComponent
              title={`Preview ${titleClick}`}
              type="component"
              content={
                <AdminShapePreview
                  variant={variant}
                  preset={preset}
                  readOnly={true}
                  height={420}
                />
              }
              buttonLabel={<i className="fa fa-eye fa-lg"></i>}
              buttonSize="sm"
              size="lg"
              messageTooltip={`Preview ${titleClick}`}
            />
          </div>
        )} */}
      </div>
    </FormGroup>
  );
}